export function treeToList(tree = [], idValue = null, childrenField = 'children', idField = 'id', parentIdField = 'parentId') {
    const list = []
    if (!childrenField) childrenField = 'children'
    for (let i = 0, j = tree.length; i < j; i++) {
        const d = tree[i]
        const id = d[idField]
        if (!list.some(l => l[idField] === id)) {
            list.push(d)
        }
        if (parentIdField) d[parentIdField] = idValue
        const children = d[childrenField]
        if (children && children.length > 0) {
            const items = treeToList(children, id, childrenField, idField, parentIdField)
            const values = items.values()
            for (const v of values) {
                if (!list.some(l => l[idField] === v[idField])) {
                    list.push(v)
                }
            }
        }
    }
    return list
}

export function listToTree(list = [], root = null, idField = 'id', parentIdField = 'parentId') {
    const tree = []
    const hash = {}
    const childrenField = 'children'
    for (let i = 0, l = list.length; i < l; i++) {
        const d = list[i]
        hash[d[idField]] = d
    }

    for (let i = 0, l = list.length; i < l; i++) {
        const d = list[i]
        const parentID = d[parentIdField]
        if (parentID === '' || parentID === 0) {
            tree.push(d)
            continue
        }

        const parent = hash[parentID]
        if (!parent) {
            tree.push(d)
            continue
        }

        let children = parent[childrenField]
        if (!children) {
            children = []
            parent[childrenField] = children
        }
        children.push(d)
    }

    if (root) {
        root[childrenField] = tree
        return [root]
    }

    return tree
}

// 移除html中的图片后格式化html
export function removeImgTags(html) {
    // 将HTML字符串解析为DOM结构
    var doc = new DOMParser().parseFromString(html, 'text/html');

    // 获取文档中所有的img标签
    var imgs = doc.getElementsByTagName('img');

    // 遍历所有找到的img标签，并从DOM中移除它们
    while (imgs[0]) {
        imgs[0].parentNode.removeChild(imgs[0]);
    }

    // 返回修改后的HTML内容（不包括被移除的img标签）
    return doc.body.textContent;
}

// 找出第一个图片的src
export function getFirstImgSrc(html) {
    // 将HTML字符串解析为DOM结构
    const doc = new DOMParser().parseFromString(html, 'text/html');

    // 获取第一个<img>元素
    const firstImg = doc.querySelector('img');

    // 如果存在<img>，返回其src属性；否则返回空字符串
    return firstImg ? firstImg.getAttribute('src').replaceAll('http://www.fjzljyxh.com/uploads/', 'http://www.fjzljyxh.com/old/uploads/') : '';
}

// 格式化日期
export function formatDateString(dateStr) {
    var str = ''
    if (dateStr) {
        dateStr = dateStr.split(' ')[0]
        // 分割原始字符串
        const parts = dateStr.split('/');

        // 补零函数
        const padZero = (num) => (num < 10 ? '0' + num : num.toString());

        const year = parts[0];
        const month = padZero(parseInt(parts[1], 10));
        const day = padZero(parseInt(parts[2], 10));
        str = `${year}-${month}-${day}`
    }
    return str;
}

// 压缩图片

